import RemoveIcon from "@mui/icons-material/RemoveCircle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import InPlaceConfirmation from "./InPlaceConfirmation";

const GdsId = (props) => {
  const [toRemove, setToRemove] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const disabled = props.disabled || inProgress;

  const onCancelRemove = () => {
    setToRemove(false);
  };

  const onConfirmRemove = () => {
    setToRemove(false);
    setInProgress(true);
    props.onRemove(props.gdsOffice).finally(() => setInProgress(false));
  };

  const onRemove = () => {
    setToRemove(true);
  };

  return (
    <InPlaceConfirmation
      inProgress={inProgress}
      onCancel={onCancelRemove}
      onConfirm={onConfirmRemove}
      open={toRemove}
    >
      <Grid container xs={12} spacing={1}>
        <Grid xs={5}>
          <TextField
            disabled={disabled}
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            label="IATA"
            readOnly
            value={props.gdsOffice?.iata}
          />
        </Grid>
        <Grid xs={6} noValidate autoComplete="off">
          <TextField
            disabled={disabled}
            fullWidth
            name="officeId"
            InputProps={{
              readOnly: true,
            }}
            label="PCC / Office ID"
            readOnly
            value={props.gdsOffice?.officeId}
          />
        </Grid>
        <Grid container xs={1} spacing={2}>
          <IconButton disabled={disabled} disableRipple onClick={onRemove}>
            <RemoveIcon />
          </IconButton>
        </Grid>
      </Grid>
    </InPlaceConfirmation>
  );
};

export default GdsId;
